import React from 'react';
import AppsHeader from './AppsHeader';
import '../../styles/form-layout.css';

const families = [
  { key: 'events', label: 'Events', description: 'Apps for events, attendees and staff.' },
  { key: 'identity', label: 'Identity', description: 'Apps for identity and credential-based interactions.' },
  { key: 'direct', label: 'Direct', description: 'Apps for recipient delivery and fulfillment.' },
];
const groups = [
  { title: 'Your apps', includes: state => state === 'open' },
  { title: 'Other apps', includes: state => state !== 'open' && state !== 'coming_soon' },
  { title: 'Coming soon', includes: state => state === 'coming_soon' },
];

export default function FamilyCatalog({ apps, renderCard, organizationName }) {
  // Temporary presentation only: keep the catalog and access states unchanged.
  const selected = 'events';
  const visible = app => app.families?.includes(selected);
  const family = families.find(entry => entry.key === selected);
  return <>
    <AppsHeader organizationName={organizationName}>
    <div className="form-tabs apps-family-tabs" role="tablist" aria-label="Application families">
      {families.filter(entry => entry.key === selected).map(entry => <button key={entry.key} type="button" role="tab"
        className={`form-tab${selected === entry.key ? ' active' : ''}`}
        id={`apps-tab-${entry.key}`} aria-controls="apps-family-panel"
        aria-selected={selected === entry.key} tabIndex={0}>{entry.label}</button>)}
    </div>
    </AppsHeader>
    <section id="apps-family-panel" role="tabpanel" aria-labelledby={`apps-tab-${selected}`} tabIndex={0}>
      <p className="apps-family-description">{family.description}</p>
      {groups.map(group => {
        const entries = apps.filter(app => group.includes(app.state));
        return <section className="apps-group" aria-label={group.title} key={group.title}
          hidden={!entries.some(visible)}>
          <h2 className="apps-group-title">{group.title}</h2>
          <div className="apps-grid">
            {/* Keep existing cards mounted; this family filter changes presentation only. */}
            {entries.map(app => <div key={app.appKey} hidden={!visible(app)}>{renderCard(app)}</div>)}
          </div>
        </section>;
      })}
      {!apps.some(visible) && <p>No applications are currently available in this family.</p>}
    </section>
  </>;
}
